/**
 * Builds the student URL to open a test linked from the temario tree.
 * @param {{ titulo?: string, bloque?: string, tema?: string }} testRef
 * @param {string} fallbackPestana
 * @returns {string}
 */
export function buildTestLaunchHref(testRef, fallbackPestana) {
  const bloqueRaw =
    typeof testRef?.bloque === "string" && testRef.bloque.trim() !== ""
      ? testRef.bloque.trim()
      : "";
  const fallbackRaw =
    typeof fallbackPestana === "string" && fallbackPestana.trim() !== ""
      ? fallbackPestana.trim()
      : "";
  const pestana = fallbackRaw || bloqueRaw;
  if (pestana.length === 0) {
    return "/usuario/campus";
  }
  const params = new URLSearchParams();
  params.set("pestana", pestana);
  if (bloqueRaw) {
    params.set("bloque", bloqueRaw);
  }
  const temaRaw = typeof testRef?.tema === "string" ? testRef.tema.trim() : "";
  const tituloRaw = typeof testRef?.titulo === "string" ? testRef.titulo.trim() : "";
  const tema = temaRaw || tituloRaw;
  if (tema) {
    params.set("tema", tema);
  }
  return `/usuario/test-temas?${params.toString()}`;
}
